import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapService } from 'src/app/services/map.service';


@Component({
  selector: 'app-field-list',
  templateUrl: './field-list.component.html',
  styleUrls: ['./field-list.component.scss'],
})
export class FieldListComponent implements OnInit {
  
  @Input() showMenu!: boolean;
  @Output() closeEvent = new EventEmitter<boolean>();

  fields = [
    {
      id: 1,
      label: 'Castilla',
      coordinates: { longitude:  -73.6660, latitude: 3.8940 },
    },
    {
      id: 2,
      label: 'Cira infantas',
      coordinates: { longitude: -73.7700, latitude: 6.9490 },
    },
  ]

  fieldSelected: number  = 1;
  constructor(private mapService: MapService) {}

  ngOnInit() {}

  closeMenu() {
    this.closeEvent.next(false);
  }

  setCenterMap(lat: number, lng: number){
    this.mapService.setCenterMap(lat, lng);
  }
}
